import { render, staticRenderFns } from "./ChangeCard.vue?vue&type=template&id=fa822f10&scoped=true&"
import script from "./ChangeCard.vue?vue&type=script&lang=js&"
export * from "./ChangeCard.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCard.vue?vue&type=style&index=0&id=fa822f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa822f10",
  null
  
)

export default component.exports